<!-- 多个颜色 -->
<template>
  <div
    class="football_cup_svgCircle"
    v-show="currThemeObj.cssStyle"
    :style="{
      '--mixtmt_strokeWidth': `${strokeWidth * 2}px`,
      '--mixtmt_svgWidth': `${cx * 2}px`,
      '--mixtmt_whiteColor': currThemeObj.cssStyle.whiteColor,
      '--mixtmt_greyColor3': currThemeObj.cssStyle.greyColor3,
      '--mixtmt_greyColor2': currThemeObj.cssStyle.greyColor2,
      '--mixtmt_greyColor0': currThemeObj.cssStyle.greyColor0,
      '--mixtmt_svgColor0': currThemeObj.cssStyle.svgColor0,
      '--mixtmt_svgColor1': currThemeObj.cssStyle.svgColor1,
      '--mixtmt_svgColor2': currThemeObj.cssStyle.svgColor2,
      '--mixtmt_svgColor3': currThemeObj.cssStyle.svgColor3,
    }"
  >
    <div class="svg_area">
      <svg
        :width="cx * 2"
        :height="cx * 2"
        :viewbox="viewbox"
        v-if="renderSvgArr && renderSvgArr.length > 1"
      >
        <circle
          v-for="(item, index) in renderSvgArr"
          :key="index"
          :class="
            item != `0 ${svgGirth}` ? `${item.strokeClass}` : 'svg_transparent'
          "
          :cx="cx"
          :cy="cy"
          :r="r"
          stroke-linecap="round"
          :stroke-width="strokeWidth"
          fill="none"
          :transform="`matrix(0,-1,1,0,0,${cx * 2})`"
          :stroke-dasharray="item.data"
        ></circle>
        <circle
          class="svg_transparent"
          :cx="cx"
          :cy="cy"
          :r="r"
          stroke-linecap="round"
          :stroke-width="strokeWidth"
          fill="none"
          :transform="`matrix(0,-1,1,0,0,${cx * 2})`"
          :stroke-dasharray="`0 ${svgGirth}`"
        ></circle>
      </svg>
      <svg
        :width="cx * 2"
        :height="cx * 2"
        :viewbox="viewbox"
        v-else-if="renderSvgArr && renderSvgArr.length == 1"
      >
        <circle
          :class="renderSvgArr[0].strokeClass"
          :cx="cx"
          :cy="cy"
          :r="r"
          stroke-linecap="round"
          :stroke-width="strokeWidth"
          fill="none"
          :transform="`matrix(0,-1,1,0,0,${cx * 2})`"
          :stroke-dasharray="`${svgGirth} 0`"
        ></circle>
      </svg>
      <div class="svg_infor">
        <span class="svg_infor_total" v-text="totalNum"></span>
        <span class="svg_infor_totalName" v-text="totalName"></span>
      </div>
    </div>
    <div class="tip_area">
      <span
        class="tip_item"
        v-for="(item, itemIndex) in svgDataArr"
        :key="itemIndex"
      >
        <span
          class="tipItem_num"
          v-text="
            item[keyArr[1]] || item[keyArr[1]] === 0 || item[keyArr[1]] === '0'
              ? item[keyArr[1]]
              : '-'
          "
        ></span>
        <span class="tipItem_name" v-text="item[keyArr[0]]"></span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'football_cup_svgCircle',
  mixins: [cup_base_data_mixin],
  props: {
    cx: {
      //圆点 x坐标
      type: Number,
      default: 67,
    },
    cy: {
      //圆点 y坐标
      type: Number,
      default: 67,
    },
    strokeWidth: {
      //描边宽度
      type: Number,
      default: 4,
    },
    svgDataArr: {
      // svg渲染数据
      type: Array,
      default: () => {
        return null
        // [{
        //   val: 150,
        //   name: '11',
        //   key: 1,
        // },]
      },
    },
    keyArr: {
      // 数据中需要的映射的字段名['name', 'val']
      type: Array,
      default: () => {
        return ['name', 'val']
      },
    },
    totalName: {
      //圆环上面文字
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    r() {
      // 圆半径
      return this.cy - this.strokeWidth / 2 - 1
    },
    svgGirth() {
      // 圆周长
      return Math.floor(Math.PI * 2 * this.r)
    },
    viewbox() {
      // svg自带参数
      return `0 0 ${this.cx * 2} ${this.cx * 2}`
    },
    totalNum() {
      let total = 0
      if (this.svgDataArr) {
        this.svgDataArr.forEach((item) => {
          total += item[this.keyArr[1]] - 0
          // resSvgDataArr.unshift(item)
        })
      }
      return total
    },
    renderSvgArr() {
      //倒序的，第一个线段在最后一个，最后一个在第一个
      if (!this.svgDataArr) {
        return [`0 ${this.svgGirth}`, `0 ${this.svgGirth}`]
      }
      let total = 0
      let renderSpacing = this.strokeWidth * 2
      let renderEndSpacing = renderSpacing

      let maxSvgVal = -1
      let maxSvgValIndexArr = [0]
      let newSvgDataArr = [] //只对有值的指标项进行计算和渲染，0或者不存在的值过滤掉
      this.svgDataArr.forEach((item, index) => {
        item.renderVal = item[this.keyArr[1]] - 0
        item.strokeClass = `svg_color${index}`
        if (item.renderVal) {
          newSvgDataArr.push(item)
        }
        total += item.renderVal //这个值是用来计算圆环百分比的值，区别于源数据中的item[this.keyArr[1]]，因为item[this.keyArr[1]]还需要展示在其他地方，所以不能动
      })
      console.debug(`total: ${total}, newSvgDataArr: ${newSvgDataArr}`)
      if (!total) {
        // 如果总是为0，需将圆环平分，但是展示值是0
        this.svgDataArr.forEach((item) => {
          item.renderVal = 10
          if (item.renderVal) {
            newSvgDataArr.push(item)
          }
          total += item.renderVal
        })
      }
      let difSvgGirth = this.svgGirth - newSvgDataArr.length * renderSpacing
      let diffVal = difSvgGirth
      let renderSvgValArr = newSvgDataArr.map((item, index) => {
        const svgVal = Math.floor((item.renderVal / total) * difSvgGirth)
        // 防止有多个相同的最大值
        // 如果只有一个maxSvgVal值则maxSvgValIndexArr数组只有一个；如果存在最大值maxSvgVal有多个，则maxSvgValIndexArr数组个数大于1；这个在最后平分剩余的值会用到
        if (maxSvgVal == svgVal) {
          maxSvgValIndexArr.push(index)
        }
        if (maxSvgVal < svgVal) {
          maxSvgVal = svgVal
          maxSvgValIndexArr = []
          maxSvgValIndexArr[0] = index
        }

        diffVal -= svgVal
        return svgVal
      })
      console.debug(`svgGirth: ${this.svgGirth}`)
      console.debug(difSvgGirth, renderSpacing, total, diffVal, renderSvgValArr)
      if (diffVal % maxSvgValIndexArr.length == 1) {
        // 防止有多个相同的最大值，然后还平分不干净
        // 多余的diffVal值能平分到最大值maxSvgVal之后还有剩余，要将剩余分最后一个间隔
        const equallyAfterDiff = diffVal % maxSvgValIndexArr.length
        renderEndSpacing += equallyAfterDiff
      }
      // 多余的diffVal值能平分到最大值maxSvgVal中
      const equally = Math.floor(diffVal / maxSvgValIndexArr.length)
      for (let i = 0; i < maxSvgValIndexArr.length; i++) {
        const index = maxSvgValIndexArr[i]
        renderSvgValArr[index] += equally
      }
      console.debug(equally, maxSvgVal, maxSvgValIndexArr, renderSvgValArr)
      const itemAllNum = renderSvgValArr.length
      let resRenderSvgArr = []
      for (let i = 0; i < itemAllNum; i++) {
        const item = renderSvgValArr[i]
        let svgStr = ''
        let spacing = 0
        // 第一个间隔
        spacing = this.strokeWidth

        for (let j = 0; j < i; j++) {
          if (j == itemAllNum - 2) {
            spacing += renderSvgValArr[j] + renderEndSpacing
          } else {
            spacing += renderSvgValArr[j] + renderSpacing
          }
        }
        svgStr = `0 ${spacing} ${item} ${this.svgGirth - item - spacing}`

        resRenderSvgArr.unshift({
          data: svgStr,
          strokeClass: newSvgDataArr[i].strokeClass,
        })
      }
      console.debug('resRenderSvgArr:', resRenderSvgArr)

      // return [
      //   {
      //     data: '0 56 222 4',
      //     strokeClass: 'svg_color2',
      //   },
      //   {
      //     data: '0 4 43 235',
      //     strokeClass: 'svg_color1',
      //   },
      // ]
      return resRenderSvgArr //['0 311 83 8', '0 203 100 99', '195 207']
    },
  },
}
</script>

<style lang="scss" scoped>
.football_cup_svgCircle {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  width: 40%;
  .svg_area {
    position: relative;
    svg {
      circle {
        -webkit-transition: stroke-dasharray 0.5s;
        transition: stroke-dasharray 0.5s;
      }
    }
    .svg_infor {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: var(--mixtmt_svgWidth);
      height: var(--mixtmt_svgWidth);
      padding: var(--mixtmt_strokeWidth);
      .svg_infor_total {
        color: var(--mixtmt_greyColor3);
        font-size: 1.805vw;
        line-height: 2.222vw;
        text-align: center;
      }
      .svg_infor_totalName {
        color: var(--mixtmt_greyColor2);
        font-size: 0.972vw;
        text-align: center;
      }
    }
  }
  .tip_area {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: calc(100% - var(--mixtmt_svgWidth));
    padding: 0 0.625vw;

    .tip_item {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 2.43vw;
      padding: 0 0.694vw 0 0;
      border-bottom: 1px solid var(--mixtmt_greyColor0);
      .tipItem_num {
        width: 3.472vw;
        padding-right: 0.55vw;
        color: var(--mixtmt_greyColor3);
        font-size: 1.388vw;
        text-align: right;
      }
      .tipItem_name {
        position: relative;
        padding-left: 0.966vw;
        &::before {
          content: '\20';
          position: absolute;
          left: 0;
          top: 50%;
          z-index: 2;
          width: 0.416vw;
          height: 0.416vw;
          border-radius: 50%;
        }
      }
      &:first-child {
        .tipItem_name {
          &::before {
            background-color: var(--mixtmt_svgColor0);
          }
        }
      }
      &:nth-child(2) {
        .tipItem_name {
          &::before {
            background-color: var(--mixtmt_svgColor1);
          }
        }
      }
      &:nth-child(3) {
        .tipItem_name {
          &::before {
            background-color: var(--mixtmt_svgColor2);
          }
        }
      }
      &:nth-child(4) {
        .tipItem_name {
          &::before {
            background-color: (--mixtmt_svgColor3);
          }
        }
      }
    }
  }

  .svg_transparent {
    stroke: var(--mixtmt_whiteColor);
  }
  .svg_color0 {
    stroke: var(--mixtmt_svgColor0);
  }
  .svg_color1 {
    stroke: var(--mixtmt_svgColor1);
  }
  .svg_color2 {
    stroke: var(--mixtmt_svgColor2);
  }
  .svg_color3 {
    stroke: var(--mixtmt_svgColor3);
  }
}
</style>
